import React, { ReactNode } from 'react';
import * as IoC from 'typescript-ioc';
import { FormattedMessage } from 'react-intl';
import { IAlertsService } from '../../../infrastructure/alerts';


type AlertConfig = {
    title?: string;
    onClose?: () => void;
};

export class JobsAlertsService {
    public static showAlert(message, config?: AlertConfig): JobsAlertsService {
        if (!message) return;

        return new JobsAlertsService(message, config);
    }

    @IoC.Inject private readonly alertService: IAlertsService;

    private readonly alertKey: string;
    private close(): void {
        if (this.alertKey) this.alertService.closeAlert(this.alertKey);
    }

    private constructor(message: string | ReactNode, config: AlertConfig = {}) {
        const { title = '', onClose } = config;
        this.alertKey = this.alertService.alert({
            message: message,
            title: title,
            renderCrossIcon: false,
            okButtonProps: {
                text: React.createElement(FormattedMessage, {id: 'oe.common.ok'}),
                handler: () => {
                    this.close.bind(this)();
                    if (onClose) onClose();
                }
            }
        });
    }
}
